var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPublishIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.6,
  d: "m10 10.488 3.536 3.535-1.18 1.179-1.523-1.524v4.655H9.167v-4.656l-1.524 1.525-1.179-1.18zm0-8.822a5.834 5.834 0 0 1 5.795 5.162A4.584 4.584 0 0 1 15 15.814v-1.678a2.916 2.916 0 1 0-.927-5.758 4.167 4.167 0 1 0-8.147 0A2.917 2.917 0 0 0 4.85 14.11l.15.025v1.678a4.583 4.583 0 0 1-.795-8.986A5.833 5.833 0 0 1 10 1.666"
})));
export { SvgPublishIcon as ReactComponent };
export default __webpack_public_path__ + "b958beadbd02472d4032d87e1afafacb.svg";